export enum DSP {
  AMAZON = 'MR2ocDuaNCWP75ZJSgTEHjdB',
  AMAZON_EQT = '437',
  AMAZON_NATIVE_B_EQT = '490',
  NEXXEN_BANNER = '9d7CMfp2nZ18hckXmDwoFxbs',
  OPENX = '6E6dnPq1ztfkuxxNupdpgjDB',
  PUBMATIC = 't2DCBn66fGJXtaXNiotHoWdn'
}

export enum PublisherKey {
  RAPTIVE_TAM = 'Z0zLtt4t',
  RAPTIVE_PREBID = 'rn56Ocs3',
  RAPTIVE_OB = '2101b770'
}
